import { memo, useState } from 'react';
import { Handle, Position, type NodeProps } from 'reactflow';
import { FileCode, Upload, FileText } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const EdiSourceNode = ({ data, selected, id }: NodeProps) => {
    const path = data.path || data.filePath;
    const label = path ? path.split('/').pop() : 'Select EDI File...';

    // Simulate App Input Toggle (Usually handled in Property Panel, but visualizing here for "Wow")
    const isAppInput = data.isAppInput;

    return (
        <BaseNodeUI
            title={data.label || 'EDI 835 Source'}
            icon={FileCode}
            colorClass="text-indigo-600"
            bgClass="bg-gradient-to-br from-indigo-50 to-white border-indigo-200"
            selected={selected}
            isRunning={data?.executionStatus === 'Running'} executionStatus={data?.executionStatus}
            isTarget={false}
            rowsProcessed={data?.rowsAffected}
        />
    );
};

export default memo(EdiSourceNode);
